
import { getTypeListApi } from '@/api/medInsuranceAccount.js';

class MedicalInsurance {
    //获取各种类别const
    static async getTypeList() {
        return new Promise((resolve, reject) => {
            getTypeListApi().then(res => {
                if (res.code == 200) {
                    let list = res.data;
                    let insuTypeList = list.filter(val => val.type == 'INSUTYPE');
                    let clrTypeList = list.filter(val => val.type == 'clrType');
                    let clrOptinsList = list.filter(val => val.type == 'clrOptins');
                    let certTypeList = list.filter(val => val.type == 'MDTRT_CERT_TYPE');
                    let statusList = list.filter(val => val.type == 'settleType');
                    let medTypeList = list.filter(val => val.type == 'MED_TYPE');
                    let psnTypeList=list.filter(val => val.type == 'PSN_TYPE');
                    let settleRelationList=list.filter(val => val.type == 'settleRelation');
                    let obj={insuTypeList,clrTypeList,clrOptinsList,certTypeList,statusList,medTypeList,psnTypeList,settleRelationList}
                    resolve(obj);
                }
            })
        })
    }
}
export {
    MedicalInsurance
}